export default "/images/help-duration.png?f3c749eb95818510ff50527733e8bd83";